import {Injectable} from '@angular/core';
import {ScrollTargetDirective} from '@domain/common/directive/scroll-target.directive';

@Injectable({
  providedIn: 'root'
})
export class ScrollManagerService {

  private readonly targets = new Map<string, ScrollTargetDirective>();

  public scroll(id: string) {
    this.targets.get(id)!.scroll();
  }

  public register(section: ScrollTargetDirective) {
    this.targets.set(section.appScrollTarget(), section);
  }

  public remove(section: ScrollTargetDirective) {
    this.targets.delete(section.appScrollTarget());
  }

}
